export const PICKUP_STATUS = {
  PENDING   : 'pending',
  REQUESTED : 'requested',
  COMPLETED : 'completed'
}

export const SHIPMENT_PROCESS = {
  WAITING_FOR_NEW_SHIPMENT: 'waiting_for_new_shipment'
}

export const SHIPMENT_COURIERS = {
  JNE          : 'Jne',
  ANTER_AJA    : 'Anter Aja',
  GRAB_EXPRESS : 'GrabExpress',
  SELF_PICKUP  : 'self_pickup'
}

export const SHIPMENT_COURIER_SERVICE_TYPES = {
  JNE: {
    REG23    : 'REG23',
    YES23    : 'YES23',
    CTC23    : 'CTC23',
    CTCYES23 : 'CTCYES23'
  },
  ANTER_AJA: {
    REG : 'REG',
    ND  : 'ND',
    SD  : 'SD'
  },
  GRAB_EXPRESS: {
    INSTANT  : 'INSTANT',
    SAME_DAY : 'SAME_DAY'
  },
  SELF_PICKUP: {
    SELFPICKUP: 'SELFPICKUP'
  }
}